import { getPhonePrefix, ValidPhoneCode } from 'ud-form/components/input/domain/formatters/format-phone';

import { AuthRequestAuthCodePayload } from 'modules/auth/domain/interfaces/auth-request-auth-code-payload';
import { Formik } from 'formik';
import React from 'react';
import { SchemaOf } from 'yup';
import UDButton from 'ud-ui/components/button';
import UDInputPhone from 'ud-form/components/input/phone';
import { useTranslation } from 'react-i18next';

type RequestAuthCodeFormProps = {
  initialValues: {
    phone: string;
  };
  isLoading: boolean;
  onSubmit: (values: AuthRequestAuthCodePayload) => void;
  validationSchema?: SchemaOf<AuthRequestAuthCodePayload>;
};

const isPhoneComplete = (phone: string, prefix: ValidPhoneCode): boolean => {
  const digitsOnly = phone.replace(/\D/g, '');

  switch (prefix) {
    case '+7':
      return digitsOnly.slice(0, 11).length === 11;
    case '+375':
      return digitsOnly.slice(0, 12).length === 12;
    case '+374':
      return digitsOnly.slice(0, 11).length === 11;
    default:
      return false;
  }
};

const RequestAuthCodeForm = (props: RequestAuthCodeFormProps) => {
  const { t } = useTranslation();

  return (
    <Formik<AuthRequestAuthCodePayload>
      initialValues={props.initialValues}
      onSubmit={props.onSubmit}
      validateOnBlur={false}
      validateOnChange={false}
      validationSchema={props.validationSchema}
    >
      {(formProps) => {
        // TODO: зачем отдельная функция на получение префикса, если можно её вызывать внутри isPhoneComplete?
        const prefix = getPhonePrefix(formProps.values.phone);
        const isComplete = isPhoneComplete(formProps.values.phone, prefix);

        return (
          <form onSubmit={formProps.handleSubmit}>
            <UDInputPhone
              autoFocus
              name="phone"
              label={t('signIn.phoneInputLabel')}
              placeholder={t('signIn.phoneInputPlaceholder')}
              wrapperProps={{ className: 'mb-4.5' }}
              value={formProps.values.phone}
              onChange={(value: string) => {
                formProps.setFieldValue('phone', value);
                if (isComplete) {
                  formProps.validateField('phone');
                }
              }}
            />
            <UDButton
              variant="primary"
              type="submit"
              className="w-100"
              style={{ fontFamily: 'SF Pro Display', fontWeight: 400 }}
              loading={props.isLoading}
              disabled={props.isLoading || !isComplete || !formProps.isValid || !formProps.dirty}
            >
              {t('signIn.requestCodeButtonLabel')}
            </UDButton>
          </form>
        );
      }}
    </Formik>
  );
};

export default RequestAuthCodeForm;
